export {default as T1T2} from './t1t2'